import React from 'react';
import PropTypes from 'prop-types';

function SummaryItem(props) {
  const { text, title } = props;
  return (
    <div className="summary-item">
      <p className="title">{title}</p>
      <p className="text">{text}</p>
    </div>
  );
}

SummaryItem.propTypes = {
  text: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default SummaryItem;
